export default "__VITE_ASSET__4e76b28f__"